/* ==========================================================================
   C6 méga-menu · L'OUVERTURE DU PANNEAU (ordinateur, vague 1)
   --------------------------------------------------------------------------
   Trois acquis de l'audit du 01/09 que ce fichier doit tenir, et que
   `c6-v1-check.mjs` mesure :

     1. OUVERTURE SOUS 120 ms. Le panneau existe déjà dans le document ; il
        n'y a rien à construire au survol. `pointerenter` retire la classe et
        la peinture arrive à la trame suivante. Mesuré à 78 ms sur l'existant,
        et ce composant ne doit pas dégrader ce chiffre.

     2. AUCUNE ZONE MORTE entre l'intitulé et le panneau. On ne la comble PAS
        par une géométrie (un chevauchement de 37 px, comme aujourd'hui, que
        le premier changement de rembourrage de section casserait) mais par
        une TEMPORISATION de fermeture, annulée dès que le pointeur entre dans
        le panneau. La diagonale intitulé → colonne de droite passe donc
        quelle que soit la hauteur de la barre.

     3. AUCUNE CIBLE SOUS 44 px. C'est l'affaire de la feuille de style ; le
        JS n'a le droit de rien réduire.

     4. L3 · LE SURVOL NE LÂCHE PAS (vague 5). Raph, le 03/09 : « quand tu
        effleures Tapis, ça s'ouvre, mais ça reste très sensible, ça s'ouvre,
        ça ne se remet pas… quand tu mets ta souris, boum, ça s'ouvre, et tu
        n'as aucun risque que ça s'enlève ou que ça se remette ». Le survol ne
        se juge pas à la lecture : `c6-v5-survol.mjs` rejoue quatre trajets de
        souris et COMPTE les bascules de `aria-expanded`. Sur l'état du 02/09,
        un seul contrôle était rouge, et c'est celui que personne n'aurait
        trouvé à la main :

          · LE DÉFILEMENT. `window.addEventListener('scroll', ferme)` fermait
            le panneau au PREMIER pixel. Six pixels de roue - l'inertie d'un
            pavé tactile sous une main posée, pas un geste - et le panneau
            disparaissait sous le pointeur, qui n'avait pas bougé. C'est mot
            pour mot « ça s'enlève ». On ferme toujours à la descente (un
            panneau de 700 px n'a rien à faire hors de l'écran quand l'en-tête
            se cache), mais après un SEUIL de 24 px, mesuré depuis la position
            d'OUVERTURE et non depuis le dernier évènement - sans quoi dix
            frémissements de deux pixels finiraient par en faire vingt.

          · LE DÉLAI passe de 140 à 220 ms, le milieu de la fourchette
            150-250 du cahier. 140 est la valeur d'un pont, pas celle d'une
            intention.

          · LA ZONE TAMPON repousse la fermeture tant que le pointeur est dans
            l'intitulé ou dans le panneau, tolérance de 24 px comprise. Elle
            est relue à chaque geste, jamais écrite en constante : voir sa
            justification et sa mesure au-dessus de `dansLaZoneTampon`.

   Ce fichier ne contient AUCUN texte affichable : il ne fait qu'ouvrir,
   fermer et mesurer. Les libellés sont posés en Liquid.
   ========================================================================== */
(function () {
  'use strict';

  /* 220 ms : le milieu de la fourchette 150-250 du cahier. En dessous, un
     aller-retour de souris ordinaire ne rentre pas ; au-dessus, le panneau
     traîne derrière un visiteur qui est passé à autre chose. */
  var DELAI_FERMETURE = 220;
  /* Sous 24 px, un défilement est un frémissement de roue ou l'inertie d'un
     pavé tactile, pas un geste. */
  var SEUIL_DEFILEMENT = 24;
  /* La tolérance de la zone tampon, autour de l'intitulé et du panneau. */
  var TOLERANCE = 24;

  document.querySelectorAll('[data-cmn]').forEach(function (racine) {
    var declencheurs = racine.querySelectorAll('[data-cmn-ouvre]');
    var panneaux = racine.querySelectorAll('[data-cmn-panneau]');
    if (!declencheurs.length || !panneaux.length) return;

    var minuterie = null;
    var ouvert = null;
    /* La position de défilement au moment de l'ouverture : c'est d'elle qu'on
       mesure le seuil, et pas du dernier évènement. */
    var yOuverture = 0;
    var ecouteEnCours = false;
    /* Échap ferme le panneau PUIS rend le focus à l'intitulé - et ce focus
       rouvrait aussitôt le panneau par le chemin clavier, si bien qu'Échap
       ne fermait rien. Le défaut n'était visible ni à la lecture ni à la
       main : il faut que le focus soit DÉJÀ sur l'intitulé pour le voir.
       Ce drapeau ne saute qu'un seul focus, celui qu'Échap provoque. */
    var sauteProchainFocus = false;

    /* ── Pleine largeur sans `100vw` ────────────────────────────────────────
       `100vw` inclut la barre de défilement : sur une machine qui en a une,
       un panneau à `100vw` déborde de 15 px et fait apparaître une barre
       horizontale sur toutes les pages du site. `clientWidth`, lui, l'exclut.
       On mesure la position du BLOC DE RÉFÉRENCE DU PANNEAU, c'est-à-dire son
       `offsetParent` réel, pour le ramener au bord gauche de la fenêtre. Il ne
       faut pas le nommer en dur : la barre a dû prendre `position: relative`
       pour passer au-dessus de l'aplat de `.header__bottom`, et elle est
       devenue de ce fait le bloc de référence à la place de `.header__bottom`.
       Un nom écrit en dur aurait décalé le panneau de 50 px sans que rien ne
       proteste. */
    var mesureEnCours = false;
    function mesure() {
      if (mesureEnCours) return;
      mesureEnCours = true;
      requestAnimationFrame(function () {
        mesureEnCours = false;
        var ancre = panneaux[0];
        var parent = ancre.offsetParent || racine.offsetParent || racine.parentElement;
        if (!parent) return;
        var r = parent.getBoundingClientRect();
        var vw = document.documentElement.clientWidth;
        racine.style.setProperty('--cmn-vw', vw + 'px');
        racine.style.setProperty('--cmn-left', Math.round(r.left) + 'px');
      });
    }

    function ferme() {
      if (!ouvert) return;
      panneaux.forEach(function (p) {
        p.classList.remove('est-ouvert');
      });
      declencheurs.forEach(function (d) {
        d.setAttribute('aria-expanded', 'false');
      });
      ouvert = null;
      /* La classe du THÈME, pas une de plus. C'est elle que
         `casemira-home-transparent-header.css` interroge pour rendre son
         opacité à l'en-tête de l'accueil : sans elle, la barre resterait
         blanche sur la photo pendant qu'un panneau blanc s'ouvre dessous. */
      document.body.classList.remove('has-dropdown-menu');
      /* A15 · la pastille de chat revient dès que le panneau se referme.
         Voir la règle et sa justification dans `casemira-c6-menu.css`. */
      document.documentElement.classList.remove('cmn-ouvert');
      arreteEcoute();
    }

    function ouvre(nom) {
      if (minuterie) {
        clearTimeout(minuterie);
        minuterie = null;
      }
      arreteEcoute();
      if (ouvert === nom) return;
      mesure();
      yOuverture = window.scrollY;
      panneaux.forEach(function (p) {
        p.classList.toggle('est-ouvert', p.dataset.cmnPanneau === nom);
      });
      declencheurs.forEach(function (d) {
        d.setAttribute('aria-expanded', String(d.dataset.cmnOuvre === nom));
      });
      ouvert = nom;
      document.body.classList.add('has-dropdown-menu');
      /* A15 · le panneau est ouvert, ce qui flotte s'efface. La classe est
         posée sur `<html>`, comme `cm-over`, parce que le widget de chat est
         un élément à racine fantôme posé en `position: fixed` : il n'est le
         descendant d'aucun de nos conteneurs, et seule la racine peut
         l'atteindre. La règle vit dans `casemira-c6-menu.css`. */
      document.documentElement.classList.add('cmn-ouvert');
    }

    function fermeDifferee() {
      if (minuterie) clearTimeout(minuterie);
      minuterie = setTimeout(ferme, DELAI_FERMETURE);
    }

    /* ══════════════════════════════════════════════════════════════════════
       L3 · LA ZONE TAMPON
       ----------------------------------------------------------------------
       GÉOMÉTRIE MESURÉE, 1440 px, accueil (`c6-v5-survol.mjs`) : l'intitulé
       finit à 173 px du haut de la fenêtre, le panneau commence à 167. Ils se
       CHEVAUCHENT de six pixels. Il n'y a donc, aujourd'hui, aucune zone
       morte à franchir - et un triangle d'intention, la réponse classique
       quand le sous-menu est de côté, n'aurait rien à faire ici : ce serait
       du code mort dans un survol, c'est-à-dire du code qui se réveille au
       mauvais moment.

       Ce qu'il faut, c'est que la temporisation ne compte pas pour un
       pointeur qui n'est pas parti. Tant qu'il est dans l'intitulé ou dans le
       panneau, tolérance de 24 px comprise, la fermeture est repoussée. Et le
       jour où les six pixels de chevauchement deviendront six pixels de vide
       - un rembourrage de section suffit à les retourner - le couloir entre
       les deux sera couvert, sans qu'une seule ligne change.

       LA TOLÉRANCE NE REMONTE JAMAIS AU-DESSUS DU BAS DE L'INTITULÉ. Le
       panneau fait toute la largeur de la fenêtre : 24 px de tolérance vers
       le haut engloberaient LAVABLES et FAIT MAIN, et le panneau ne se
       fermerait plus jamais en passant sur eux. Le plafond de la zone est
       donc le bas de l'intitulé - le couloir, et rien de plus.

       On n'écoute `pointermove` QUE pendant qu'une fermeture est en attente :
       un écouteur permanent sur `document` coûterait sur toutes les pages du
       site pour un menu que la plupart des visiteurs n'ouvrent jamais. */
    function dansLaZoneTampon(x, y) {
      if (!ouvert) return false;
      var p = racine.querySelector('[data-cmn-panneau="' + ouvert + '"]');
      if (!p) return false;
      var rp = p.getBoundingClientRect();
      if (!rp.height) return false;
      var d = racine.querySelector('[data-cmn-ouvre="' + ouvert + '"]');
      var rd = d ? d.getBoundingClientRect() : null;
      if (rd &&
          x >= rd.left - TOLERANCE && x <= rd.right + TOLERANCE &&
          y >= rd.top - TOLERANCE && y <= rd.bottom + TOLERANCE) return true;
      var haut = rd ? Math.min(rp.top, rd.bottom) : rp.top;
      return x >= rp.left - TOLERANCE && x <= rp.right + TOLERANCE &&
             y >= haut && y <= rp.bottom + TOLERANCE;
    }

    function surLeTrajet(ev) {
      if (!minuterie) {
        arreteEcoute();
        return;
      }
      if (dansLaZoneTampon(ev.clientX, ev.clientY)) fermeDifferee();
    }

    function arreteEcoute() {
      if (!ecouteEnCours) return;
      document.removeEventListener('pointermove', surLeTrajet);
      ecouteEnCours = false;
    }

    function suisLeTrajet() {
      if (ecouteEnCours) return;
      document.addEventListener('pointermove', surLeTrajet);
      ecouteEnCours = true;
    }

    declencheurs.forEach(function (d) {
      var nom = d.dataset.cmnOuvre;
      d.addEventListener('pointerenter', function (ev) {
        /* Un appui au doigt émet lui aussi `pointerenter`. Sur un écran
           tactile, on laisse le lien naviguer : le tiroir mobile (vague 2)
           est la bonne réponse, pas un panneau de 700 px de haut. */
        if (ev.pointerType === 'touch') return;
        ouvre(nom);
      });
      d.addEventListener('focus', function () {
        if (sauteProchainFocus) {
          sauteProchainFocus = false;
          return;
        }
        ouvre(nom);
      });
      d.addEventListener('pointerleave', function (ev) {
        if (ev.pointerType === 'touch') return;
        suisLeTrajet();
        fermeDifferee();
      });
    });

    panneaux.forEach(function (p) {
      p.addEventListener('pointerenter', function () {
        if (minuterie) {
          clearTimeout(minuterie);
          minuterie = null;
        }
        arreteEcoute();
      });
      p.addEventListener('pointerleave', function () {
        suisLeTrajet();
        fermeDifferee();
      });
    });

    /* Le focus qui quitte l'ensemble ferme : c'est le pendant clavier du
       `pointerleave`, et c'est ce qui évite qu'un panneau reste ouvert
       derrière un visiteur qui tabule jusqu'au pied de page. */
    racine.addEventListener('focusout', function (ev) {
      if (!racine.contains(ev.relatedTarget)) ferme();
    });

    /* Échap ferme, sans exception, et rend le focus à l'intitulé. */
    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape' || !ouvert) return;
      var cible = racine.querySelector('[data-cmn-ouvre="' + ouvert + '"]');
      ferme();
      if (cible) {
        sauteProchainFocus = true;
        cible.focus();
      }
    });

    /* Le panneau suit l'en-tête, qui se cache à la descente : on ferme
       plutôt que de laisser un panneau de 700 px glisser hors de l'écran.
       Mais après un SEUIL (L3) : six pixels de roue fermaient le panneau sous
       un pointeur qui n'avait pas bougé, et c'est le seul contrôle rouge de
       `c6-v5-survol` sur l'état du 02/09. */
    window.addEventListener('scroll', function () {
      if (!ouvert) return;
      if (Math.abs(window.scrollY - yOuverture) < SEUIL_DEFILEMENT) return;
      ferme();
    }, { passive: true });
    window.addEventListener('resize', function () {
      mesure();
      ferme();
    });

    mesure();
  });
})();
